import type {WebSourcesVariant} from './web-sources.types';
import {WEB_SOURCES_VARIANT_COPY} from './web-sources.types';

export function getSourcesLabel(variant: WebSourcesVariant, sourceCount: number): string {
  const {oneSourceKey, manySourcesKey} = WEB_SOURCES_VARIANT_COPY[variant];

  return sourceCount === 1 ? window.i18next.t(oneSourceKey) : window.i18next.t(manySourcesKey, {count: sourceCount});
}

export function parseWebSourcesVariant(value: unknown): WebSourcesVariant {
  return value === 'read' ? 'read' : 'search';
}
